module.exports = __webpack_public_path__ + "img/dropdown_account.0d0760dd.svg";